import { OperationTypeEnum } from "@gtpl/shared-models/common-models";

export class GradeInventoryRequest{
    plantId: number;
    operation: OperationTypeEnum;
}